import React from 'react';
import { SkeletonLoader } from '../';
import { getInitials } from '../../helpers';

import './Photo.css';

export const Photo = ({
  data,
  name,
  alt,
  className,
  type = 'USER',
  size = 'small',
  tooltip = '',
  loading,
}) => {
  name = name || '?';
  let avatar = 'owner'; //"group-photo"

  switch (type) {
    case 'USER':
      avatar = 'owner'; //"user-photo"
      break;
    case 'SERVICE_ACCOUNT':
      avatar = 'service-account-photo';
      break;
    case 'USER_GROUP':
      avatar = 'owner'; //"group-photo"
      break;
    default:
      break;
  }

  return (
    <div
      className={
        'Photo ' +
        (!data ? ' placeholder ' : ' ') +
        type.toLowerCase() +
        ' ' +
        size +
        (className ? ' ' + className : '')
      }
    >
      {loading ? (
        <SkeletonLoader className={'photo-loader ' + size} />
      ) : data ? (
        <img
          className="photo-img"
          title={tooltip}
          src={'data:image/jpeg;base64,' + data}
          alt={alt || name}
        />
      ) : (
        <div className={'photo-img icon-' + avatar} title={tooltip}>
          {name && type !== 'SERVICE_ACCOUNT' && getInitials(name)}
        </div>
      )}
    </div>
  );
};
